var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":"1000","title":"资源排队情况","footer-hide":true},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('Table',{attrs:{"columns":_vm.queueColumns,"data":_vm.queueData,"stripe":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }